import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "@/lib/content";
import { SectionLabel, RevealLines, FadeUp } from "../site/motion";

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.8", "end 0.6"] });
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);
  return (
    <section data-testid="process-section" className="relative overflow-hidden bg-cream py-24 text-skaris-ink md:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <SectionLabel n="(05)" className="!text-skaris-accent [&_span:first-child]:!bg-skaris-accent [&_span:nth-child(2)]:!text-skaris-ink/60">How we deliver</SectionLabel>
            <RevealLines inView as="h2" lines={["Fixed phases.", "No surprises."]}
              className="mt-6 font-display text-4xl font-semibold uppercase leading-[0.95] tracking-[-0.03em] text-skaris-navy sm:text-5xl lg:text-7xl" />
          </div>
          <FadeUp className="lg:col-span-4 lg:col-start-9">
            <p className="font-body text-base text-skaris-ink/80">Every engagement is scoped and priced phase-by-phase, so you know exactly what to expect — and what you will have — at each milestone.</p>
          </FadeUp>
        </div>
        <div ref={ref} className="relative mt-16">
          <div className="absolute left-0 right-0 top-[22px] hidden h-px bg-skaris-ink/15 md:block" />
          <motion.div style={{ scaleX }} className="absolute left-0 right-0 top-[22px] hidden h-px origin-left bg-skaris-navy md:block" />
          <div className="grid gap-10 md:grid-cols-4">
            {PROCESS.map((s, i) => (
              <FadeUp key={s.n} delay={i * 0.1} data-testid={`process-step-${s.n}`} className="relative">
                <span className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full border border-skaris-navy bg-cream font-mono text-xs text-skaris-navy">{s.n}</span>
                <h3 className="mt-8 font-display text-2xl font-semibold text-skaris-navy">{s.title}</h3>
                <p className="mt-3 font-body text-sm leading-relaxed text-skaris-ink/75">{s.body}</p>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
